import React from 'react';
import Loading from 'components/_common/Loading';

const AgentStatsV = ({
    params,
    setParams,
    handleChange
}) => {
    const { isLoaded, error, agentStatsData, selectedYear, selectedMonth } = params;

    return (
        <>
            {isLoaded && error == null ? (
                <>
                    <div className="content-header">
                        <h1>
                            <span>출장자별 통계 ({selectedYear}년{selectedMonth ? ` ${selectedMonth}월` : ''})</span>
                        </h1>
                    </div>

                    <div className="container-fluid">
                        {/* 년도/월 선택 필터 */}
                        <div className="row mb-3">
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label>분석 년도</label>
                                    <select
                                        className="form-control"
                                        value={selectedYear}
                                        onChange={(e) => handleChange(e, 'selectedYear', e.target.value)}
                                    >
                                        <option value="2026">2026년</option>
                                        <option value="2025">2025년</option>
                                        <option value="2024">2024년</option>
                                        <option value="2023">2023년</option>
                                        <option value="2022">2022년</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label>분석 월</label>
                                    <select
                                        className="form-control"
                                        value={selectedMonth || ''}
                                        onChange={(e) => handleChange(e, 'selectedMonth', e.target.value)}
                                    >
                                        <option value="">전체</option>
                                        <option value="1">1월</option>
                                        <option value="2">2월</option>
                                        <option value="3">3월</option>
                                        <option value="4">4월</option>
                                        <option value="5">5월</option>
                                        <option value="6">6월</option>
                                        <option value="7">7월</option>
                                        <option value="8">8월</option>
                                        <option value="9">9월</option>
                                        <option value="10">10월</option>
                                        <option value="11">11월</option>
                                        <option value="12">12월</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        {/* 출장자별 통계 테이블 */}
                        <div className="card">
                            <div className="card-header">
                                <h3 className="card-title">출장자별 통계</h3>
                            </div>
                            <div className="card-body p-0">
                                <table className="table table-striped table-bordered">
                                    <thead>
                                        <tr>
                                            <th style={{ width: '150px' }}>출장자</th>
                                            <th style={{ width: '120px' }}>출장건수(년월)</th>
                                            <th style={{ width: '120px' }}>휴일근무건수</th>
                                            <th style={{ width: '120px' }}>바탁물청소건수</th>
                                            <th style={{ width: '150px' }}>출장비용</th>
                                            <th style={{ width: '150px' }}>이익</th>
                                            <th style={{ width: '120px' }}>무상출장건수</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {agentStatsData.length > 0 ? (
                                            agentStatsData.map((agent, index) => (
                                                <tr key={index}>
                                                    <td>{agent.agent}</td>
                                                    <td className="text-center">
                                                        <span className="badge bg-primary">
                                                            {agent.tripCount}건
                                                        </span>
                                                    </td>
                                                    <td className="text-center">
                                                        <span className="badge bg-warning">
                                                            {agent.holidayCount}건
                                                        </span>
                                                    </td>
                                                    <td className="text-center">
                                                        <span className="badge bg-info">
                                                            {agent.floorCleanCount}건
                                                        </span>
                                                    </td>
                                                    <td className="text-right">
                                                        {agent.tripFeeAmount.toLocaleString()}원
                                                    </td>
                                                    <td className="text-right">
                                                        <span className={agent.profit >= 0 ? 'text-success' : 'text-danger'}>
                                                            {agent.profit.toLocaleString()}원
                                                        </span>
                                                    </td>
                                                    <td className="text-center">
                                                        <span className="badge bg-secondary">
                                                            {agent.freeCount}건
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={7} className="text-center text-muted py-4">
                                                    데이터가 없습니다
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <Loading />
            )}
        </>
    );
};

export default AgentStatsV;